export const tableOptions = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  menuWidth: 180,
  align: 'center',
  refreshBtn: false,
  showClomnuBtn: false,
  searchSize: 'mini',
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  props: {
    label: 'label',
    value: 'value'
  },
  column: [{
    label: "申诉者Full Name",
    width: 120,
    prop: 'appealBy',
    solt: true
  }, {
    label: "申诉者姓名",
    width: 120,
    prop: 'appealByRealname',
    solt: true
  }, {
    label: '申诉描述',
    prop: 'reason',
    width: 200,
    overHidden: true
  }, {
    label: '被下架内容类别',
    prop: 'appealType',
    width: 80,
    solt: true
  }, {
    label: '申诉附件',
    prop: 'appealAttachments',
    width: 80,
    solt: true
  }, {
    label: '被下架内容',
    prop: 'content',
    width: 280,
    solt: true,
    overHidden: true
  }, {
    label: '状态',
    prop: 'status',
    width: 80,
    solt: true
  }, {
    label: '申诉时间',
    prop: 'appealTime',
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss'
  }]
}

export const AppealTypes = [
  { label: '内容', value: 0 },
  { label: '评论', value: 1 }
]
